// extracted by mini-css-extract-plugin
module.exports = {"padding":"core_padding__Vfr4m"};